module.exports = __webpack_public_path__ + "img/match2.dcfbd83e.jpg";